import React, { useState, useEffect, useRef } from 'react';
import './ModernTabs.css';

const ModernTabs = ({
  tabs = [],
  defaultActiveTab = 0,
  orientation = 'horizontal', // 'horizontal' | 'vertical'
  variant = 'modern',         // 'modern' | 'minimal' | 'pills'
  className = ''
}) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const [loadedTabs, setLoadedTabs] = useState([defaultActiveTab]); // Track which tabs have been loaded
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const tabHeaderRef = useRef(null);
  const isVertical = orientation === 'vertical';

  useEffect(() => {
    updateIndicator();
  }, [activeTab, orientation, variant, tabs]);

  const updateIndicator = () => {
    if (!tabHeaderRef.current) return;
    const activeButton = tabHeaderRef.current.querySelector('.tab-btn.active');
    if (!activeButton) return;

    const headerRect = tabHeaderRef.current.getBoundingClientRect();
    const buttonRect = activeButton.getBoundingClientRect();

    if (variant === 'pills') {
      setIndicatorStyle({});
      return;
    }

    if (isVertical) {
      setIndicatorStyle({
        top: `${buttonRect.top - headerRect.top}px`,
        height: `${buttonRect.height}px`,
        width: '3px',
        opacity: 1
      });
    } else {
      setIndicatorStyle({
        left: `${buttonRect.left - headerRect.left}px`,
        width: `${buttonRect.width}px`,
        height: '3px',
        opacity: 1
      });
    }
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
    // Mark tab as loaded so it remains mounted
    setLoadedTabs((prev) => (prev.includes(index) ? prev : [...prev, index]));
  };

  return (
    <div className={`modern-tabs ${className} ${isVertical ? 'vertical' : 'horizontal'} variant-${variant}`}>
      {/* Header */}
      <div
        ref={tabHeaderRef}
        className={`tab-header ${isVertical ? 'vertical' : 'horizontal'}`}
      >
        <div className="tab-buttons">
          {tabs.map((tab, index) => (
            <button
              key={tab.id || index}
              className={`tab-btn ${activeTab === index ? 'active' : ''}`}
              onClick={() => handleTabClick(index)}
            >
              {tab.icon && <i className={`${tab.icon} tab-icon me-1`}></i>}
              <span className="tab-label">{tab.label}</span>
              {tab.badge && <span className="tab-badge">{tab.badge}</span>}
            </button>
          ))}
        </div>
        {variant !== 'pills' && <div className="tab-indicator" style={indicatorStyle}></div>}
      </div>

      {/* Content */}
      <div className="tab-content">
        {tabs.map((tab, index) =>
          loadedTabs.includes(index) ? (
            <div
              key={tab.id || index}
              className={`tab-pane ${activeTab === index ? 'active' : 'd-none'}`}
            >
              {tab.content}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ModernTabs;
